import { Pipe, PipeTransform } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from '../../../../core/core.state'
import { SaleItem } from '../sale-item'
import { Observable } from 'rxjs'
import { SaleItemPriceDetails, SaleItemService } from '../sale-item.service'
import { courseSelectors } from 'src/app/features/course/course.selectors'

@Pipe({
  name: 'getSaleItemCoursePrice'
})
export class GetSaleItemCoursePricePipe implements PipeTransform {
  courseEntities$ = this.store.select(courseSelectors.selectEntities)

  constructor(
    private store: Store<AppState>,
    private saleItemService: SaleItemService
  ) {}

  transform(saleItem: SaleItem): Observable<SaleItemPriceDetails> {
    return this.saleItemService.getSaleItemCoursePrice$(saleItem)
  }
}
